import script from "./temp2.vue?vue&type=script&setup=true&lang=js"
export * from "./temp2.vue?vue&type=script&setup=true&lang=js"

import "./temp2.vue?vue&type=style&index=0&id=b58b2462&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b58b2462"]])

export default __exports__